export function formatDataTestAttribute(dataTest: string, componentName: string, uiName: string): string {
    if (!dataTest) return '';

    return dataTest + `-${componentName + uiName}`;
}
